export default [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'app.home',
      icon: 'mdi-home',
      tenant: true
    }
  },
  {
    path: '/:tenant/help',
    name: 'help',
    component: () => import(/* webpackChunkName: "help" */ '../views/home/Help'),
    meta: {
      title: 'Hjälp',
      icon: 'mdi-lifebuoy',
      tenant: true
    }
  },
  {
    path: '/init',
    name: 'init',
    component: () => import(/* webpackChunkName: "home" */ '../views/settings/CreateTenantView'),
    meta: {
      title: 'Skapa ny organisation',
      icon: 'mdi-bank',
      permission: 'tenant:create'
    }
  },
  {
    path: '/init/select',
    name: 'tenant-select',
    component: () => import(/* webpackChunkName: "home" */ '../views/settings/SelectTenantView'),
    meta: {
      title: 'Välj organisation',
      icon: 'mdi-bank'
    }
  },
  {
    path: '/init/join',
    name: 'tenant-invite',
    component: () => import(/* webpackChunkName: "home" */ '../views/settings/InvitationView'),
    meta: {
      title: 'Mina inbjudningar',
      icon: 'mdi-heart'
    }
  },
  {
    path: '/:tenant',
    name: 'home-tenant',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/TenantHome'),
    meta: {
      title: 'app.home',
      icon: 'mdi-home',
      tenant: true
    }
  },
  {
    path: '/:tenant/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/Dashboard'),
    meta: {
      title: 'avtala.dashboard.label',
      icon: 'mdi-home',
      menu: true,
      tenant: true
    }
  },
  {
    path: '/:tenant/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/settings/UserProfile'),
    meta: {
      title:'Användarprofil',
      icon: 'mdi-settings',
      tenant: true
    }
  },
  {
    path: '/:tenant/init/select',
    name: 'tenant-switch',
    component: () => import(/* webpackChunkName: "home" */ '../views/settings/SelectTenantView'),
    meta: {
      title: 'Välj organisation',
      icon: 'mdi-bank',
      tenant: true
    }
  }
]
